import type { RouteRecordRaw } from 'vue-router';
import WrapperView from '@/shared/views/WrapperView.vue';
import NavigationRailView from '@/services/router/views/NavigationRailView.vue';
import LeadListView from '@/lead/lead/views/LeadListView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/contacten',
        name: 'lead',
        components: {
            default: WrapperView,
            rail: NavigationRailView,
        },
        redirect: { name: 'lead-list' },
        children: [
            {
                path: '',
                name: 'lead-list',
                components: {
                    default: LeadListView,
                },
            },
        ],
    },
];

export default routes;
